import {CoreDI, IEventManagerWithAsync, inject, injectable, IService, System, SystemComponentType} from '@gongxigames/framework/core';
import {SlotSettings} from '@gongxigames/framework/slot/configs/SlotSettings';

@injectable()
export class AutotestService implements IService {
    public static NAME = 'AutotestService';
    public type: SystemComponentType = 'service';

    private _cheatsReady = false;

    @inject(CoreDI.Settings)
    private readonly _settings!: SlotSettings;

    @inject(CoreDI.System)
    private readonly _system!: System;

    @inject(CoreDI.IEventManagerWithAsync)
    private readonly _eventManager!: IEventManagerWithAsync;

    public init(): void {
        this.connectToAutotest();

        this._eventManager.on('CheatModule.initialized', this._onCheatsReady.bind(this), this);
    }

    private _onCheatsReady(): void {
        this._cheatsReady = true;
    }

    private connectToAutotest() {
        const isAutotestUsed = window.__PIXI_TESTER__ && window.__RUBY_GAME_TESTER__;

        this._settings.set('skipHardwareAccelerationDisabledMessage', Boolean(isAutotestUsed));

        if (isAutotestUsed) {
            window.__PIXI_TESTER__!.register(this._system.app);
            window.__RUBY_GAME_TESTER__!.register(this.getAPI());
        }
    }

    private isCheatsReady(): boolean {
        return this._cheatsReady;
    }

    private getAPI(): Record<string, any> {
        return {
            _eventManager: this._eventManager,
            _ticker: this._system.ticker,
            _isCheatsReady: this.isCheatsReady.bind(this)
        };
    }
}
